import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Button, Container, Dialog, Typography, Grid, CircularProgress } from '@mui/material';
import styles from './lotsMapDialogStyles';
import { notification } from '../../../utils/Notifications';
import useLogout from '../../../hooks/auth/authHook.js';
import { assignLotsLocation } from '../../../api/lotsApi';

LotsMapDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function LotsMapDialog({ onClose, open, lot, fetchLots }) {
  const [logout] = useLogout();

  const initialPosition = lot.latitude && lot.longitude ? { lat: lot.latitude, lng: lot.longitude } : null;

  const [position, setPosition] = useState(initialPosition);
  const [isLoading, setIsLoading] = useState(false);

  const customMarker = new L.Icon({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    shadowSize: [41, 41],
  });

  const LocationMarker = ({ position, setPosition }) => {
    const map = useMapEvents({
      click(e) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      },
    });

    return position === null ? null : (
      <Marker position={position} icon={customMarker}>
        <Popup>Ubicación seleccionada</Popup>
      </Marker>
    );
  };

  const handleAssingLocationClick = () => {
    if(isLoading) { return; }
    setIsLoading(true);
    updateLocation();
  }

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  const updateLocation = () => {

    if(position === null) { return; }

    assignLotsLocation(lot.id_location, position.lat, position.lng)
      .then((response) => {
        if (response.data.status_Code === 200) {
          notification({ text: "Dirección cambiada", type: "success" });
          fetchLots();
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener los lotes",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{
        style: styles.dialog,
        sx: { maxWidth: { xs: '100%', sm: '90%', md: '90%' }, height: { xs: '90%', sm: '80%', md: '80%' } }
      }}
    >
      <Container sx={styles.mainContainer}>
        <Typography component="div" variant="h5" sx={styles.title}>
          Asignar dirección
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MapContainer center={[19.989611, -102.284604]} zoom={5} style={styles.mapContainer}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              <LocationMarker position={position} setPosition={setPosition} />
            </MapContainer>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="flex-end" sx={styles.gridContainer}>
          <Grid item>
            <Button
              variant="outlined"
              onClick={() => handleDialogClose()}
              style={styles.cancelButton}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              disabled={!position}
              onClick={() => handleAssingLocationClick()}
              sx={position ? styles.activeButton : styles.inactiveButton}
            >
              {isLoading ? <CircularProgress size={24} sx={styles.circularProgress} /> : 'Asignar'}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
    
  );
}